export const projects = [
  {
    id: "spreadx-store-manager",
    title: "SpreadX Store Manager",
    eyebrow: "Production • UAE • POS • Offline-first • Hardware integration",
    description: "Production Flutter POS and business-management application supporting multi-branch UAE retail operations across sales, inventory, invoicing, fulfillment, and warehouse workflows.",
    fullDescription: "I work across Flutter application development and native Android integrations using Kotlin and Java. The product connects multi-branch sales, inventory, invoicing, customer and supplier, kitchen and fulfillment, and warehouse workflows. My responsibilities include offline-first synchronization, REST APIs, Firebase, WebSockets, receipt printers, barcode scanners, POS hardware, production debugging, and operational support.",
    technologies: ["Flutter", "Dart", "Kotlin", "Java", "REST APIs", "Firebase", "WebSockets", "Offline-first", "Receipt Printers", "Barcode Scanners"],
    type: "mobile",
    featured: true,
    homepageCoverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714728/ChatGPT_Image_Aug_14_2026_05_06_48_PM_znirbg.png",
    coverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714746/photo_2026-08-07_13-32-16_hscvoa.jpg",
    media: ["https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714728/ChatGPT_Image_Aug_14_2026_05_06_48_PM_znirbg.png"],
    links: {
      website: "https://spreadx.ae/",
      appStore: "https://apps.apple.com/us/app/spreadx-store-manager-pos/id6514317681",
      playStore: "https://play.google.com/store/apps/details?id=com.spread.lite&hl=en"
    }
  },
  {
    id: "travel-operations-platform",
    title: "Travel Operations Platform",
    eyebrow: "End-to-end architecture • Backend ownership • Mobile integration",
    description: "Travel operations product spanning a Laravel 12 and PostgreSQL backend, JWT-secured REST APIs, a role-based admin dashboard, and Flutter applications.",
    fullDescription: "An end-to-end travel operations platform built around Laravel 12, PostgreSQL, JWT authentication, REST APIs, a role-based admin dashboard, and Flutter integration. My work covers backend and database ownership as well as AI-assisted implementation, debugging, and testing while retaining responsibility for the resulting production code.",
    technologies: ["Laravel 12", "PostgreSQL", "JWT", "REST APIs", "Flutter", "Role-based Architecture"],
    type: "web",
    featured: true,
    homepageCoverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786719083/Screenshot_651_yrh80g.png",
    coverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786719083/Screenshot_651_yrh80g.png",
    media: ["https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786719085/Screenshot_652_hretib.png"],
    links: {}
  },
  {
    id: "xpin-graphrag",
    title: "XPIN AI",
    eyebrow: "AI / GraphRAG / Full-Stack",
    description: "A full-stack Hierarchical GraphRAG system that combines vector retrieval and knowledge-graph traversal to produce grounded, evidence-backed answers from uploaded documents.",
    fullDescription: "XPIN AI demonstrates practical AI application engineering through hierarchical retrieval, structured knowledge-graph extraction, backend orchestration, and a full-stack evidence-aware chat experience. It searches child chunks in Qdrant, expands matches to parent context, traverses typed relationships in Neo4j, and fuses both evidence paths before grounded LLM generation. The system exposes ingestion and chat APIs through FastAPI and presents streamed answers, citations, provenance, and graph context in React.",
    architecture: "Documents → hierarchical chunking → Qdrant vector index + Neo4j knowledge graph → LangGraph retrieval workflow → vector search + graph traversal → fused grounding context → LLM → grounded answer with evidence and citations",
    capabilities: [
      "Hierarchical parent-child document chunking",
      "Child-level vector search with parent-context expansion",
      "Structured entity and typed relationship extraction",
      "Multi-hop graph traversal and vector + graph evidence fusion",
      "Grounded generation with citations and provenance",
      "PDF, TXT, and Markdown document ingestion",
      "SSE streaming with an interactive React chat UI",
      "Docker Compose environment with backend validation and tests"
    ],
    technologies: ["Python", "FastAPI", "LangGraph", "Neo4j", "Qdrant", "React", "Docker", "LLM APIs", "SSE"],
    type: "web",
    media: [],
    links: {
      github: "https://github.com/MoSallah21/graphrag"
    }
  },
  {
    id: "noor-go",
    title: "Noor Go",
    eyebrow: "Real-time mobility • Maps • WebSockets",
    description: "Ride-hailing application connecting passenger and driver workflows through live location tracking, Socket.IO updates, Firebase services, and Google Maps.",
    fullDescription: "A real-time ride-hailing application built for passenger and driver operations. I developed Flutter workflows integrating live GPS tracking, Socket.IO updates, Firebase authentication, messaging and storage, Google Maps, trip management, and a NestJS backend using Clean Architecture and BLoC.",
    technologies: ["Flutter", "Firebase", "NestJS", "Socket.IO", "Google Maps", "Clean Architecture", "BLoC"],
    type: "mobile",
    coverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714418/Feature_Graphic_auwe8w.png",
    media: ["https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714699/ChatGPT_Image_Aug_14_2026_04_54_12_PM_kj0jdz.png"],
    links: {
      appStore: "https://apps.apple.com/us/app/noor-go/id6754198953",
      playStore: "https://play.google.com/store/apps/details?id=com.paradox.noorgo_customer&hl=en"
    }
  },
  {
    id: "work-accounts",
    title: "Work Accounts",
    eyebrow: "ERP • Accounting workflows • Local-first data",
    description: "Flutter ERP and accounting application covering invoices, budgets, income and expenses, reporting, multi-currency workflows, and an integrated accounting assistant.",
    fullDescription: "An ERP-style accounting application built with Flutter and SQLite. I implemented invoice generation, budgets, income and expense tracking, multi-currency workflows, financial reporting, and an integrated accounting assistant, organized around maintainable application architecture and local data persistence.",
    technologies: ["Flutter", "Dart", "SQLite", "REST API", "ERP Workflows"],
    type: "mobile",
    coverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714498/7550105-02_1_p1prk2.png",
    media: [
      "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714532/3_t3hvh9.jpg",
      "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714530/2_nqvc0h.jpg"
    ],
    links: {}
  },
  {
    id: "eks-warehouse-management",
    title: "EKS — Warehouse Management",
    eyebrow: "Inventory • Barcode workflows • Operational reporting",
    description: "Flutter warehouse application connected to backend services for inventory, barcode scanning, orders, suppliers, stock monitoring, and operational reporting.",
    fullDescription: "A warehouse-management application covering inventory and stock monitoring, barcode scanning, order and supplier workflows, and operational reporting. I built the Flutter application and its REST API integrations with Firebase services and a PHP/MySQL backend.",
    technologies: ["Flutter", "Firebase", "PHP", "MySQL", "REST API", "Barcode Scanning"],
    type: "mobile",
    coverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714511/7550105-02_c4ogh2.png",
    media: [
      "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714549/31_cuwp38.png",
      "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786714575/image788_oikapi.png"
    ],
    links: {
      github: "https://github.com/MoSallah21/warehouses_app",
      download: "https://t.me/mosallah47/3"
    }
  }
];

export const professionalProjects = [
  {
    id: "damen",
    title: "Damen — ضامن",
    eyebrow: "Remote professional project • Mobile application",
    description: "A professional mobile application delivered through remote company work, with contributions to the product's Flutter implementation and delivery.",
    fullDescription: "Professional mobile application work completed as part of a remote company engagement. My role involved contributing to the Flutter product implementation and delivery within the wider company team.",
    technologies: ["Flutter", "Dart", "Mobile Application Development"],
    type: "mobile",
    coverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786715766/photo_1_2026-08-14_17-50-04_k0glxj.jpg",
    media: [
      "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786715508/photo_4_2026-08-14_17-50-04_q9ja9s.jpg",
      "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786715506/photo_3_2026-08-14_17-50-04_jwieut.jpg"
    ],
    links: {
      appStore: "https://apps.apple.com/sa/app/damen-%D8%B6%D8%A7%D9%85%D9%86/id6456889883",
      playStore: "https://play.google.com/store/apps/details?id=net.damenapp.damen&hl=ar"
    }
  },
  {
    id: "mo-ai-agent",
    title: "Mo AI Agent",
    eyebrow: "AI application • Clean Architecture • Local storage",
    description: "An AI-powered chatbot app built with Flutter using Clean Architecture, BLoC, and dependency injection, with dark and light themes and local chat storage.",
    fullDescription: "An AI-powered chatbot application built with Flutter using Clean Architecture, BLoC, and dependency injection. It supports dark and light themes and stores chats locally.",
    technologies: ["Flutter", "Dart", "Clean Architecture", "BLoC", "Dependency Injection", "Local Storage"],
    type: "mobile",
    coverImage: "https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786716303/Logo_1_ghvjgq.png",
    media: ["https://res.cloudinary.com/dcvdvhe5s/image/upload/v1786716296/darkl_chat_2_ef5gov.png"],
    links: {
      github: "https://github.com/MoSallah21/mo_ai_agent",
      download: "https://t.me/mosallah47/6"
    }
  }
];

export const otherProjects = [
  { id: "premier-league-dataset", title: "Premier League Dataset", description: "1,140+ match samples across three seasons prepared for predictive analysis.", type: "dataset", link: "https://www.kaggle.com/datasets/mohamadsallah5/english-premier-league-stats20212024" },
  { id: "esnad-tax-uae", title: "Esnad Tax UAE", description: "Responsive company website for a UAE accounting and tax consultancy.", type: "web", link: "https://www.esnadtax.com/" },
  { id: "noor-go-dashboard", title: "Noor Go Operations Dashboard", description: "Web administration interface for users, rides, operational data, and real-time oversight.", type: "web", link: "https://noor-dashboard-plum.vercel.app/" }
];

export const allCaseStudyProjects = [...projects, ...professionalProjects];
export const trainingProjects = [];
export const aiProjects = [...projects, ...professionalProjects].filter((project) => ["xpin-graphrag", "mo-ai-agent"].includes(project.id));

export const skillGroups = [
  { title: "Mobile Engineering", items: ["Flutter", "Dart", "Kotlin", "Java"] },
  { title: "Backend & APIs", items: ["Laravel", "REST APIs", "PHP", "Python"] },
  { title: "Data", items: ["PostgreSQL", "MySQL", "Firebase", "SQLite / Drift"] },
  { title: "Real-Time & Offline", items: ["WebSockets", "Firebase", "Offline-first synchronization"] },
  { title: "Architecture & Engineering", items: ["Clean Architecture", "BLoC", "Provider", "Modular architecture", "Production debugging"] },
  { title: "AI-Assisted Engineering", items: ["Codex", "Claude Code", "Implementation", "Debugging", "Refactoring", "Testing"] },
  { title: "Integrations", items: ["POS hardware", "Receipt printers", "Barcode scanners", "Payment / API integrations"] }
];
